import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface IAgButtonRendererParams extends ICellRendererParams {
  className?:string;
  onClick(params:IAgButtonRendererParams):void;
  label:string;
  icon?:string;
  disabled?:boolean;
  busy?:boolean;
}

@Component({
  selector: 'ag-button',
  template: `
    <button class="btn" [ngClass]="params.className" (click)="params.onClick(params)" [disabled]="params.disabled || params.busy" [busyButton]="params.busy" [bbReplaceIcon]="true" [bbIconMargin]="false" [bbPreventDisable]="true" translate>
      <i *ngIf="params.icon" class="fa {{params.icon}}"></i><span *ngIf="params.label">&nbsp;{{params.label}}</span>
    </button>
  `
})
export class AgButtonRendererComponent implements ICellRendererAngularComp {
  public params!:IAgButtonRendererParams;

  public agInit(params:IAgButtonRendererParams):void {
    this.params = params;
  }

  public refresh(params:IAgButtonRendererParams):boolean {
    this.params = params;
    return true;
  }
}